/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React from 'react'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import { AppBannerWrapper, ZeroBannerWrapper, UserWrapper, TabContainer } from './AppBanner.style'
import logo from '../../images/Swoosh-Logo.svg'

/**
 * Primary heading banner for the app
 *
 * @name AppBanner
 */

function AppBanner({ userName }) {
	logger.log(process.env.NODE_ENV)
	if (isMobile) {
		return (
			<AppBannerWrapper>
				<ZeroBannerWrapper>
					<div style={{ display: 'flex', flexDirection: 'row' }}>
						<img
							src={logo}
							alt='logo'
							style={{
								height: '61px',
								lineHeight: '61px',
								width: '36px',
							}}
						/>
						<a
							id='High Five'
							title='High Five'
							href={`${window.location.origin}/submit`}
							style={{
								fontSize: '24px',
								fontWeight: '500',
								font: 'HelveticaNeue',
								fontColor: 'black',
								marginLeft: '8px',
							}}
						>
							High Five
						</a>
					</div>
				</ZeroBannerWrapper>
			</AppBannerWrapper>
		)
	}

	return (
		<AppBannerWrapper>
			<ZeroBannerWrapper>
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<a
						id='High Five'
						title='High Five'
						href={`${window.location.origin}/submit`}
						style={{
							fontSize: '24px',
							font: 'HelveticaNeue',
							fontColor: 'black',
							fontWeight: '500',
							marginLeft: '8px',
						}}
					>
						High Five
					</a>
				</div>
				{userName && (
					<TabContainer>
						<a
							className='pt2-sm'
							id='Send a High Five'
							title='Send a High Five'
							href={`${window.location.origin}/submit`}
							style={{
								borderBottom: window.location.pathname === '/login' ? '2px solid #061B38' : null,
								paddingRight: '5px',
								color: null,
								height: '61px',
								fontSize: '16px',
								flexShrink: 0,
							}}
						>
							Give a High Five
						</a>
						<a
							className='pt2-sm'
							id='About Nike Maxims'
							title='About Nike Maxims'
							href={`${window.location.origin}/about`}
							style={{
								borderBottom: window.location.pathname === '/about' ? '2px solid #061B38' : null,
								paddingRight: '5px',
								color: null,
								height: '61px',
								fontSize: '16px',
								flexShrink: 0,
							}}
						>
							About
						</a>
						<a
							className='pt2-sm'
							id='Go to Dashboard'
							title='See your High Fives'
							href={`${window.location.origin}/dashboard`}
							style={{
								borderBottom:
									window.location.pathname === '/dashboard' || window.location.pathname === '/manager-dashboard'
										? '2px solid #061B38'
										: null,
								paddingLeft: '5px',
								color: null,
								height: '61px',
								fontSize: '16px',
							}}
						>
							History
						</a>
					</TabContainer>
				)}
				{/* Only display username if you are logged in */}
				{userName && <UserWrapper>{userName}</UserWrapper>}
			</ZeroBannerWrapper>
		</AppBannerWrapper>
	)
}

AppBanner.propTypes = {
	userName: PropTypes.string,
}

AppBanner.defaultProps = {
	userName: '',
}

export default AppBanner



// WEBPACK FOOTER //
// ./src/components/AppBanner/AppBanner.js